import LabelWeex from "../elements/LabelWeex";
import {ElementStyles} from "../elements/ElementStyles";
import {useContext, useEffect, useState} from "react";
import {APIContext} from "../Globals.tsx";

export default function ComponentList({routeTo, search, components, setComponent, ...props}){
  const [list, setList] = useState(components);
  const styles = {
    container: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: ElementStyles.color2,
      color: ElementStyles.color,
      padding: ElementStyles.paddingLabels,
      minHeight: ElementStyles.height,
      alignItems: "center",
      textWrap: "noWrap",
      minWidth: 250,
      maxHeight: "50vh",
      overflowY: "scroll"
    },
    labels: {background: "var(--accent)", color: "var(--lightgray)", marginBottom: 5, fontWeight: "bold"}
  };
  const {searchComponentsByTag, searchComponents, deleteComponent} = useContext(APIContext);

  useEffect(() => {
    if(search){
      searchComponentsByTag(search?.map((tag) => tag.value).join(",")).then(ans => {
        setList(ans?.components?.filter(c => !c.deletedAt));
      });
    }
    else{
      searchComponents("").then(ans => {
        setList(ans?.components?.filter(c => !c.deletedAt && c.description !== "Personal Record"));
      });
    }
  }, []);

  function onDelete(e, element){
    deleteComponent(element.id).then((r) => r && setList(prev => prev.filter(c => c.id !== element.id)));
    e.stopPropagation();
  }

  if(!list || list?.length === 0){
    return (<div style={styles.container} {...props}>
      <div style={styles.border}>
        {!list ? "Laden..." : "Leider nichts gefunden..."}
      </div>
    </div>);
  }
  else{
    return (<div className={"keep-scroll"} style={styles.container} {...props}>
      <div>
        {list.map((element, i) => {
          return (<LabelWeex key={"listElement_" + i} style={styles.labels}
                             tooltip={element.description}
                             onClick={() => {
                               setComponent(element);
                               routeTo(element.id);
                             }} onDelete={(e) => onDelete(e, element)}>{element.name}</LabelWeex>);
        })}
      </div>
    </div>);
  }
}